import { createService } from './utils';
import getKnowledgeBaseArticle from '~controllers/service/knowledge-base-article';
export default () => {
    const knowledgeBaseArticle = createService('knowledge-base-articles', 'knowledgeBaseArticleId');
    const useGetKnowledgeBaseArticle = knowledgeBaseArticle.addQuery({
        controller: getKnowledgeBaseArticle,
        middleware: [],
    });
    return {
        service: knowledgeBaseArticle,
        hooks: {
            useGetKnowledgeBaseArticle,
        },
    };
};
